<template>
  <footer class=" mt-[10px] tablet:mt-0 laptop:mt-[40px] largeDesktop:mt-0 overflow-hidden
         before:content-['']
         before:absolute before:inset-0
         before:bg-[url('@/assets/images/footer-bg.svg')]
         before:bg-top before:bg-cover mobile:before:h-[160px] laptop:before:h-[170px] largeDesktop:before:h-[240px] before:bottom-0 before:top-auto
         before:z-0 relative w-full" >
    <div class="relative !flex items-center justify-center tablet:gap-[10px] laptop:gap-[15px] z-10 ">
      <div>
        <img src="../../../assets/images/man-image.png" alt="img"
          class="mobile:h-[200px] tablet:h-[185px] laptop:h-[210px] largeDesktop:h-[290px] object-cover">
      </div>
      <div
        class="flex flex-col mobile:gap-[10px] desktop:gap-[10px] largeDesktop:gap-[15px]  mobile:pb-0 mobile:!mb-[5px] tablet:!mb-0 mobile:!mt-[35px] tablet:!mt-[20px] laptop:!mt-[30px] largeDesktop:!mt-[50px]">
        <img src="../../../assets/images/myHappyHomeLogo.svg" alt=""
          class="mobile:w-[120px] mobile:h-[50px] tablet:w-[155px] tablet:h-[60px] laptop:w-[195px] laptop:h-[80px] largeDesktop:w-[235px] largeDesktop:h-[105px] object-contain">
      </div>
    </div>
  </footer>
</template>

